// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  reportId: __t.u64().primaryKey().name("report_id"),
  droidId: __t.u64().name("droid_id"),
  owner: __t.identity(),
  droidName: __t.string().name("droid_name"),
  kind: __t.string(),
  title: __t.string(),
  bodyJson: __t.string().name("body_json"),
  at: __t.timestamp(),
});
